export default {
    dateHelperChips: {
        toolbarAria: 'Date range helpers',
        applyDay: 'Apply day',
        applyWeek: 'Apply week (Mon–Sun)',
        applyWeekend: 'Apply weekend',
        applyMonth: 'Apply month',
        applyQuarter: 'Apply quarter',
        applyYear: 'Apply year',
    },
}
